import type { ButtonConfig } from '../../declare'
import { useContext } from 'react'
import { toJS } from 'mobx'
import { Button } from 'antd'
import { EasyIcon, ListTableContext, EditContext } from 'src/components'
import { appStore } from 'src/stores'
import { getValidNavColumns, getDefaultValueFrom_DEFAULT_VALUE } from 'src/components/root/helper'
import { guid } from 'src/utils/tools'

type Props = {
  config: ButtonConfig
}

const AddBtn = (props: Props) => {
  const table = useContext(ListTableContext)
  const edit = useContext(EditContext)

  const handleAddRow = () => {
    const { __CONTEXT__: editTable, __PARENT_RECORD__: parentRecord } = props.config
    const { Nav_Columns = [], Nav_PageEdit } = editTable.activeTableConfig
    const rowData: any = {
      __EDITABLE__: true,
      ID: guid(),
      ORG_ID: appStore.current.headers.OrgId,
      ENTITY_ORG_TPYE: Nav_PageEdit.EDIT_PAGE_ENTITY_ORG_TYPE || 0,
    }
    Nav_PageEdit.RELATION_FIELD && (rowData[Nav_PageEdit.RELATION_FIELD] = parentRecord?.ID ?? edit.formBase.ID)
    getValidNavColumns(Nav_Columns).forEach((item: any) => {
      const value = getDefaultValueFrom_DEFAULT_VALUE(item.DEFAULT_VALUE, {
        user: appStore.current.userinfo,
        formBase: edit.formBase,
        record: table?.selectedRow
      })
      value !== undefined && (rowData[item.FIELD_NAME] = value)
    })
    const copyDataSource = toJS(editTable.activeTableData?.dataSource || [])
    editTable.activeTable.setDataSource(copyDataSource.concat(rowData))
  }

  const { __READONLY__, LABEL, ICON } = props.config
  return (
    <Button
      type='primary'
      disabled={__READONLY__}
      icon={<EasyIcon type={ICON} defaultIcon='PlusOutlined' />}
      onClick={handleAddRow}
    >{LABEL}</Button>
  )
}

export default AddBtn